import { render, staticRenderFns } from "./OrderDetailTop.vue?vue&type=template&id=d50127fe&scoped=true&"
import script from "./OrderDetailTop.vue?vue&type=script&lang=js&"
export * from "./OrderDetailTop.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailTop.vue?vue&type=style&index=0&id=d50127fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50127fe",
  null
  
)

export default component.exports